import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Impact from './components/Impact';
import Sectors from './components/Sectors';
import Portfolio from './components/Portfolio';
import Ecosystem from './components/Ecosystem';
import Team from './components/Team';
import Stories from './components/Stories';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Impact />
      <Sectors />
      <Portfolio />
      <Ecosystem />
      <Team />
      <Stories />
      <Footer />
    </>
  );
}

export default App;
